<div class="pinpad-ticket-banner" *ngIf="CardTermNotice" uppDataid="pinpad-ticket-notice"
    [class.--with-menu]="CanUnlockCardTerm">
    <ion-item color="warning" class="warning" lines="none">
        <ion-icon slot="start" name="alert-circle-outline"></ion-icon>
        <ion-label>
            {{tr(CardTermNotice)}}<br/>
            <span class="small" *ngIf="CardTermSubtitle">{{tr(CardTermSubtitle)}}</span>
        </ion-label>
    </ion-item>
    <upp-select
        *ngIf="CanUnlockCardTerm"
        class="pinpad-ticket-banner__select"
        uppDataid="pinpad-ticket-menu">
        <upp-select-item>
            <ion-icon name="caret-down"></ion-icon>
        </upp-select-item>
        <upp-select-list>
            <upp-select-option value="check" (Select)="OnCardTermCheck()">
                <ion-item uppDataid="pinpad-ticket-check" lines="none" button detail="false">
                    <ion-label>{{tr(CardTermUnlockKind === 'RE' ? '@ticket_cardterm_unlock_check_refund' : '@ticket_cardterm_unlock_check')}}</ion-label>
                    <ion-icon slot="end" name="refresh-outline"></ion-icon>
                </ion-item>
            </upp-select-option>
            <upp-select-option value="mark-paid" (Select)="OnCardTermAskMarkPaid()">
                <ion-item uppDataid="pinpad-ticket-mark-paid" lines="none" button detail="false">
                    <ion-label>{{tr(CardTermUnlockKind === 'RE' ? '@ticket_cardterm_unlock_paid_refund' : '@ticket_cardterm_unlock_paid')}}</ion-label>
                    <ion-icon slot="end" name="checkmark-circle-outline"></ion-icon>
                </ion-item>
            </upp-select-option>
            <upp-select-option value="mark-unpaid" (Select)="OnCardTermAskMarkUnpaid()">
                <ion-item uppDataid="pinpad-ticket-mark-unpaid" lines="none" button detail="false">
                    <ion-label>{{tr(CardTermUnlockKind === 'RE' ? '@ticket_cardterm_unlock_unpaid_refund' : '@ticket_cardterm_unlock_unpaid')}}</ion-label>
                    <ion-icon slot="end" name="close-circle-outline"></ion-icon>
                </ion-item>
            </upp-select-option>
        </upp-select-list>
    </upp-select>
</div>

<upp-dialog *ngIf="CardTermDialog !== null"
    [backdropDismiss]="false"
    uppDataid="pinpad-ticket-dialog"
    style="--upp-dialog-panel-width: 420px"
    (OnClose)="OnCardTermDialogClose()">
    <div *ngIf="CardTermDialog === 'unreachable'" class="pinpad-ticket-dialog">
        <upp-dialog-header>
            <ion-header>
                <ion-toolbar color="warning">
                    <ion-title slot="start">{{tr('@ticket_cardterm_unlock_unreachable_title')}}</ion-title>
                    <ion-buttons slot="end">
                        <ion-button uppDataid="pinpad-ticket-dialog-close" (click)="OnCardTermDialogClose()">
                            <ion-icon slot="icon-only" name="close-outline"></ion-icon>
                        </ion-button>
                    </ion-buttons>
                </ion-toolbar>
            </ion-header>
        </upp-dialog-header>
        <upp-dialog-content>
            <div class="pinpad-ticket-dialog__body">
                <ion-card class="pinpad-ticket-dialog__card pinpad-ticket-dialog__card--warning">
                    <ion-icon name="help-circle" color="warning"></ion-icon>
                    <ion-card-title color="warning">{{tr('@ticket_cardterm_unlock_unreachable')}}</ion-card-title>
                </ion-card>
            </div>
        </upp-dialog-content>
        <upp-dialog-footer class="pinpad-ticket-dialog__footer">
            <ion-button uppDataid="pinpad-ticket-dialog-ok" size="large" expand="block" color="warning" (click)="OnCardTermDialogClose()">
                {{tr('@ok')}}
            </ion-button>
        </upp-dialog-footer>
    </div>
    <div *ngIf="CardTermDialog === 'mark-paid' || CardTermDialog === 'mark-unpaid'" class="pinpad-ticket-dialog">
        <upp-dialog-header>
            <ion-header>
                <ion-toolbar color="warning">
                    <ion-title slot="start">{{tr(CardTermDialogTitle)}}</ion-title>
                    <ion-buttons slot="end">
                        <ion-button uppDataid="pinpad-ticket-dialog-close" (click)="OnCardTermDialogClose()">
                            <ion-icon slot="icon-only" name="close-outline"></ion-icon>
                        </ion-button>
                    </ion-buttons>
                </ion-toolbar>
            </ion-header>
        </upp-dialog-header>
        <upp-dialog-content>
            <div class="pinpad-ticket-dialog__body">
                <ion-card class="pinpad-ticket-dialog__card pinpad-ticket-dialog__card--warning">
                    <ion-icon name="help-circle" color="warning"></ion-icon>
                    <ion-card-title color="warning">{{tr(CardTermDialogMessage)}}</ion-card-title>
                </ion-card>
            </div>
        </upp-dialog-content>
        <upp-dialog-footer class="pinpad-ticket-dialog__footer">
            <ion-button uppDataid="pinpad-ticket-dialog-accept" size="large" expand="block" color="success" (click)="OnCardTermDialogAccept()">
                {{tr('@yes')}}
            </ion-button>
            <ion-button uppDataid="pinpad-ticket-dialog-cancel" expand="block" fill="clear" color="success" (click)="OnCardTermDialogClose()">
                {{tr('@no')}}
            </ion-button>
        </upp-dialog-footer>
    </div>
</upp-dialog>
